/* global __CLIENT__ */

import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

// @TODO Use this component everywhere, where we play youtube videos (for example on the music pages that have videos)
// @TODO Use it also in the mobileAppTransformHTML. (Note: The complete app breaks when doing this, even the main app, not only the webview. No idea why :( ...)

const Youtube = ({ videoId, height, width, allowFullScreen = true }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        return () => {
            // Remove this player from the players array, when unmounting
            if (__CLIENT__ && window.YT && window.YT.players) {
                delete window.YT.players[videoId];
            }
        };
    }, [videoId]);

    const _onReady = (player) => {
        if (__CLIENT__ && window.YT) {
            // Add this player to the players array
            window.YT.players = window.YT.players || {};

            window.YT.players[videoId] = player;
        }
    };

    const _onPlay = (_videoId) => {
        if (__CLIENT__ && window.YT && window.YT.players) {
            // Loop over all the players and stop all, except this one
            Object.keys(window.YT.players).forEach((__videoId) => {
                if (__videoId !== _videoId) {
                    window.YT.players[__videoId].player.player.pause();
                }
            });
        }
    };

    // On the server, ReactPlayer with `light` renders an empty wrapper div.
    // On the client first render it renders a preview image — causing a #418 hydration mismatch.
    // Render the same empty wrapper until after hydration, then swap in ReactPlayer.
    if (!isMounted) {
        return <div style={{ width: width || '100%', height: height || '100%' }} />;
    }

    return (
        <ReactPlayer
            url={`https://www.youtube.com/watch?v=${videoId}`}
            config={{
                youtube: {
                    playerVars: {
                        fs: allowFullScreen ? 1 : 0,
                    },
                },
            }}
            light={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            controls
            height={height || '100%'}
            width={width || '100%'}
            playing // This starts the player once the preview image was clicked
            onPlay={() => _onPlay(videoId)}
            onReady={(event) => _onReady(event)}
        />
    );
};

Youtube.propTypes = exact({
    videoId: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
    allowFullScreen: PropTypes.bool,
});

export default Youtube;
